var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F3D8B",
    d: "M.206 8.862zl3.675-3.656a.703.703 0 0 1 .992.997L2.406 8.656h14.89a.703.703 0 0 1 0 1.406H2.407l2.467 2.455a.703.703 0 0 1-.992.997L.207 9.858a.704.704 0 0 1 0-.996"
  })));
};
export default SvgArrowBack;